import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { Capacitor } from "@capacitor/core";
import { initializeNativeUiLanguagePreference, normalizeContourUiLanguage } from "./deviceLanguage";

import enLanding from "../locales/en/landing.json";
import enMenu from "../locales/en/menu.json";
import enSearch from "../locales/en/search.json"; 
import enEvents from "../locales/en/events.json";
import enVault from "../locales/en/vault.json";
import enAuth from "../locales/en/auth.json";
import enOnboarding from "../locales/en/onboarding.json";
import enRating from "../locales/en/rating.json";
import enCommon from "../locales/en/common.json";
import enShop from "../locales/en/shop.json";
import enAbout from "../locales/en/about.json";
import enCommunities from "../locales/en/communities.json";
import enGuide from "../locales/en/guide.json";

import ruLanding from "../locales/ru/landing.json";
import ruMenu from "../locales/ru/menu.json";
import ruSearch from "../locales/ru/search.json";
import ruEvents from "../locales/ru/events.json";
import ruVault from "../locales/ru/vault.json";
import ruAuth from "../locales/ru/auth.json";
import ruOnboarding from "../locales/ru/onboarding.json";
import ruRating from "../locales/ru/rating.json";
import ruCommon from "../locales/ru/common.json";
import ruShop from "../locales/ru/shop.json";
import ruAbout from "../locales/ru/about.json";
import ruCommunities from "../locales/ru/communities.json";
import ruGuide from "../locales/ru/guide.json";

import skLanding from "../locales/sk/landing.json";
import skMenu from "../locales/sk/menu.json";
import skSearch from "../locales/sk/search.json";
import skEvents from "../locales/sk/events.json";
import skVault from "../locales/sk/vault.json";
import skAuth from "../locales/sk/auth.json";
import skOnboarding from "../locales/sk/onboarding.json";
import skRating from "../locales/sk/rating.json";
import skCommon from "../locales/sk/common.json";
import skShop from "../locales/sk/shop.json";
import skAbout from "../locales/sk/about.json";
import skCommunities from "../locales/sk/communities.json";
import skGuide from "../locales/sk/guide.json";

import csLanding from "../locales/cs/landing.json";
import csMenu from "../locales/cs/menu.json";
import csSearch from "../locales/cs/search.json";
import csEvents from "../locales/cs/events.json";
import csVault from "../locales/cs/vault.json";
import csAuth from "../locales/cs/auth.json";
import csOnboarding from "../locales/cs/onboarding.json";
import csRating from "../locales/cs/rating.json";
import csCommon from "../locales/cs/common.json";
import csShop from "../locales/cs/shop.json";
import csAbout from "../locales/cs/about.json";
import csCommunities from "../locales/cs/communities.json";
import csGuide from "../locales/cs/guide.json";

export default

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        landing: enLanding,
        menu: enMenu,
        search: enSearch,
        events: enEvents,
        vault: enVault,
        auth: enAuth,
        onboarding: enOnboarding,
        rating: enRating,
        common: enCommon,
        shop: enShop,
        about: enAbout,
        communities: enCommunities,
        guide: enGuide
      },
      ru: {
        landing: ruLanding,
        menu: ruMenu,
        search: ruSearch,
        events: ruEvents,
        vault: ruVault,
        auth: ruAuth,
        onboarding: ruOnboarding,
        rating: ruRating,
        common: ruCommon,
        shop: ruShop,
        about: ruAbout,
        communities: ruCommunities,
        guide: ruGuide
      },
      sk: {
        landing: skLanding,
        menu: skMenu,
        search: skSearch,
        events: skEvents,
        vault: skVault,
        auth: skAuth,
        onboarding: skOnboarding,
        rating: skRating,
        common: skCommon,
        shop: skShop,
        about: skAbout,
        communities: skCommunities,
        guide: skGuide
      },
      cs: {
        landing: csLanding,
        menu: csMenu,
        search: csSearch,
        events: csEvents,
        vault: csVault,
        auth: csAuth,
        onboarding: csOnboarding,
        rating: csRating,
        common: csCommon,
        shop: csShop,
        about: csAbout,
        communities: csCommunities,
        guide: csGuide
      }
    },
    // The initial native render starts in a European language. LocaleProvider
    // applies the bootstrapped account contour before the first paint.
    lng: Capacitor.isNativePlatform()
      ? normalizeContourUiLanguage(initializeNativeUiLanguagePreference(), "EU")
      : "en",
    fallbackLng: {
      en: [],
      sk: ["en"],
      cs: ["sk", "en"],
      ru: [],
      default: ["en"],
    },
    ns: ["landing", "menu", "search", "events", "vault", "auth", "onboarding", "rating", "common", "shop", "about", "communities", "guide"],
    defaultNS: "landing",
    interpolation: {
      escapeValue: false,
    },
  });
